import React, { useEffect, useState } from "react";
import EmployeeSearch from "./EmployeeSearch";
import { getManagerEmployeeList } from "./apis/EmployeeSearchApi";

const EmployeeSearchManager = ({ onSelect, preselectedEmployee = null, useRsEmployeeId = false }) => {
    const [empList, setEmpList] = useState([]);
    const [isEmpsLoading, setIsEmpsLoading] = useState(true);

    useEffect(() => {
        async function fetchEmployees() {
            try {
                const employees = await getManagerEmployeeList();
                setEmpList(employees);
                setIsEmpsLoading(false);
            } catch (error) {
                console.error("Error fetching manager employee list:", error);
                setIsEmpsLoading(false);
            }
        }

        fetchEmployees();

    }, [preselectedEmployee]);

    return (
        <EmployeeSearch
            employeeList={empList}
            isLoading={isEmpsLoading}
            onSelect={onSelect}
            preselectedEmployee={preselectedEmployee}
            useRsEmployeeId={useRsEmployeeId}
        />
    );
};

export default EmployeeSearchManager;